/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Footer_DescriptionInputs */

const en_gc_home_footer_description = /** @type {(inputs: Gc_Home_Footer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An independent guide to GridCraft by ArtCraft. Practical tutorials, official downloads and a workspace to explore.`)
};

const zh_gc_home_footer_description = /** @type {(inputs: Gc_Home_Footer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立整理的 GridCraft 使用指南。发现实用教程、官方下载入口，以及随时可以开始的在线工作区。`)
};

/**
* | output |
* | --- |
* | "An independent guide to GridCraft by ArtCraft. Practical tutorials, official downloads and a workspace to explore." |
*
* @param {Gc_Home_Footer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_footer_description = /** @type {((inputs?: Gc_Home_Footer_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Footer_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_footer_description(inputs)
	return zh_gc_home_footer_description(inputs)
});
export { gc_home_footer_description as "gc.home.footer_description" }